import * as Sentry from '@sentry/browser';

if (window.sentry && (!window.sentry.appEnv || ['staging', 'production'].includes(window.sentry.appEnv))) {
    Sentry.init({
        dsn: window.sentry.dsn,

        // Only allow errors from project domain to be logged
        allowUrls: window.sentry.allowUrls,
    });
}
